import { render } from "./Header_en_m.vue?vue&type=template&id=672ff4d7&scoped=true"
import script from "./Header_en_m.vue?vue&type=script&lang=js"
export * from "./Header_en_m.vue?vue&type=script&lang=js"

import "./Header_en_m.vue?vue&type=style&index=0&id=672ff4d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-672ff4d7"

export default script